import { PropertyNames } from "../../../../enums/PropertyNames";
import { PropertyTypes } from "../../../../enums/PropertyTypes";
import { ISchema, ISchemaAction, ISchemaChild, ISchemaFilter, ISchemaProperty } from "../Schema";
import { NotEmptyString, ValidAddress, ValidateEmail, ValidatePhoneNumber } from "../../../../Validation/Validation";
import { FilterTypes } from "../../../../enums/FilterTypes";
import { FilterMatchType } from "../../../../enums/FilterMatchType";
import { EntityNames } from "../../../../enums/EntityNames";
import { EntityViewTypes } from "../../../../enums/EntityViewTypes";
import {  ActionTypes } from "../../../../enums/ActionTypes";
import editIcon from "../../../../assets/icons/icon-pen-white.svg"
import { ActionStyles } from "../../../../enums/ActionStyles";
import SidePanelCustomers from "../../layout/SidePanel/layouts/SidePanelCustomers";
import { hasPermission } from "../../../../modules/auth/Permissions/PermissionModule";
import { PermissionConcerns, PermissionTypes } from "../../../../modules/auth/Permissions/PermissionStrings";

export const CustomerSchema: ISchema = {
    displayName: "Customers",
    GetSidePanelComponent: (data, onViewPage) => <SidePanelCustomers data={data} onViewPage={onViewPage} />,
    props: [
        {
            name: 'id',
            type: PropertyTypes.string,
            key: true
        } as ISchemaProperty,
        {
            name: 'name',
            displayName: 'Customer name',
            descriptor: true,
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: true,
            showInView: false,
            requiredInForm: true,
            validateRule: NotEmptyString as Function,
            validationError: "Name cannot be empty",
            autocomplete: "organization",
        } as ISchemaProperty,
        {
            name: 'number',
            displayName: 'ID number',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: true,
            showInView: false,
            requiredInForm: true,
        } as ISchemaProperty,
        {
            name: 'accountAmount',
            displayName: 'Number of active accounts',
            type: PropertyTypes.number,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty,
        {
            name: 'status',
            displayName: 'Status',
            type: PropertyTypes.status,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty,
        {
            name: 'address',
            displayName: 'Address',
            type: PropertyTypes.address,
            key: false,
            showInList: false,
            showInForm: true,
            group:0,
            requiredInForm: true,
            validateRule: ValidAddress as Function
        } as ISchemaProperty,
        {
            name: 'contactDetails',
            displayName: 'Contact Details',
            type: PropertyTypes.contactDetails,
            key: false,
            showInList: false,
            showInForm: true,
            group:1,
            showInView: false,
            requiredInForm: false,
            children: [
                {
                    name: "telephone",
                    validateRule: ValidatePhoneNumber as Function,
                    validationError: "Please enter valid phone number",
                    autocomplete: "tel",
                } as ISchemaProperty,
                {
                    name: "mobile",
                    validateRule: ValidatePhoneNumber as Function,
                    validationError: "Please enter valid phone number",
                    autocomplete: "tel",
                } as ISchemaProperty,
                {
                    name: "fax",
                    autocomplete: "tel",
                } as ISchemaProperty,
                {
                    name: "email",
                    validateRule: ValidateEmail as Function,
                    validationError: "Please enter valid email",
                    autocomplete: "email",
                } as ISchemaProperty,
            ]
        } as ISchemaProperty,
    ],

    primaryFilter: {
        PropertyName: "Name",
        displayName: "Search",
        type: FilterTypes.search,
        required: false,
        className: "width--full",
        matchType: FilterMatchType.Substring,
        propertyType: PropertyTypes.string,
        placeHolder: "Enter a customer name"
    } as ISchemaFilter,

    filters: [],

    children: [
        { 
            entityName: EntityNames.accounts, 
            displayName: "Accounts", 
            cantView: false, 
            viewType: EntityViewTypes.list, 
            enableFilters: true, 
            navPropertyName: "CustomerId", 
            canAdd: ((ctx) => hasPermission(ctx.permissions, PermissionTypes.read, PermissionConcerns.Accounts) && hasPermission(ctx.permissions, PermissionTypes.write, PermissionConcerns.Add_Account)),
            permissionToView: ((ctx) => hasPermission(ctx.permissions, PermissionTypes.read, PermissionConcerns.Accounts))
        } as ISchemaChild
    ],

    sidePanelActions: [
        {text: "Edit Details", action: ActionTypes.edit, style: ActionStyles.primary, icon: editIcon } as ISchemaAction,
    ]
}
